import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Politique de confidentialité</h1>
        <p className="privacy-intro">
          <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-CA', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Naturellement Vert Fertilisation (« NVF », « nous », « notre ») s'engage à protéger 
            la confidentialité et la sécurité de vos renseignements personnels. Cette politique 
            explique comment nous recueillons, utilisons, divulguons et protégeons vos renseignements 
            personnels conformément à la <strong>Loi 25 du Québec</strong> (Loi modernisant des dispositions 
            législatives en matière de protection des renseignements personnels).
          </p>
        </div>

        <div className="privacy-section">
          <h2>2. Responsable de la protection des renseignements personnels</h2>
          <p>
            <strong>Naturellement Vert Fertilisation</strong><br />
            NEQ : 2280919921<br />
            Email : info@nvfertilisation.com<br />
            Téléphone : 450 210 1858
          </p>
        </div>

        <div className="privacy-section">
          <h2>3. Renseignements que nous recueillons</h2>
          <h3>3.1 Renseignements que vous nous fournissez directement :</h3>
          <ul>
            <li><strong>Informations de contact :</strong> prénom, nom, adresse, courriel, numéro de téléphone</li>
            <li><strong>Informations sur votre propriété :</strong> adresse du terrain, superficie, coordonnées géographiques du périmètre</li>
            <li><strong>Services demandés :</strong> types de services de fertilisation souhaités</li>
            <li><strong>Source de référence :</strong> comment vous avez entendu parler de nous</li>
            <li><strong>Photos et notes :</strong> photos de votre terrain et notes que vous partagez avec nous (optionnel)</li>
          </ul>

          <h3>3.2 Renseignements collectés automatiquement :</h3>
          <ul>
            <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de visite</li>
            <li><strong>Cookies :</strong> petits fichiers stockés sur votre appareil pour améliorer votre expérience</li>
            <li><strong>Données de localisation :</strong> lorsque vous utilisez notre outil de cartographie (avec votre consentement)</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>4. Utilisation de vos renseignements personnels</h2>
          <p>Nous utilisons vos renseignements personnels pour :</p>
          <ul>
            <li>Traiter vos demandes de soumission et vous fournir nos services</li>
            <li>Communiquer avec vous concernant votre demande et nos services</li>
            <li>Calculer la superficie de votre terrain pour établir une soumission précise</li>
            <li>Améliorer notre site web et nos services</li>
            <li>Respecter nos obligations légales</li>
            <li>Prévenir la fraude et assurer la sécurité de notre site</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>5. Divulgation de vos renseignements personnels</h2>
          <p>
            Nous <strong>ne vendons jamais</strong> vos renseignements personnels. Nous pouvons les 
            partager uniquement dans les cas suivants :
          </p>
          <ul>
            <li><strong>Fournisseurs de services :</strong> entreprises qui nous aident à opérer notre site 
            (hébergement, outils de cartographie Google Maps, service d'envoi d'emails)</li>
            <li><strong>Obligations légales :</strong> si la loi l'exige ou pour protéger nos droits</li>
            <li><strong>Votre consentement :</strong> avec votre autorisation explicite</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>6. Vos droits en vertu de la Loi 25</h2>
          <p>Vous avez les droits suivants concernant vos renseignements personnels :</p>
          
          <div className="privacy-rights">
            <div className="privacy-right">
              <h4>✓ Droit d'accès</h4>
              <p>Obtenir une copie de vos renseignements personnels que nous détenons</p>
            </div>
            <div className="privacy-right">
              <h4>✓ Droit de rectification</h4>
              <p>Corriger vos renseignements personnels s'ils sont inexacts ou incomplets</p>
            </div>
            <div className="privacy-right">
              <h4>✓ Droit à l'oubli</h4>
              <p>Demander la suppression de vos renseignements personnels dans certaines circonstances</p>
            </div>
            <div className="privacy-right">
              <h4>✓ Droit de retirer votre consentement</h4>
              <p>Retirer votre consentement à tout moment pour l'utilisation de vos renseignements</p>
            </div>
            <div className="privacy-right">
              <h4>✓ Droit de déposer une plainte</h4>
              <p>Déposer une plainte auprès de la Commission d'accès à l'information du Québec</p>
            </div>
          </div>

          <p className="privacy-exercise-rights">
            <strong>Pour exercer vos droits, contactez-nous :</strong><br />
            Email : info@nvfertilisation.com<br />
            Téléphone : 450 210 1858<br />
            Ou utilisez notre <a href="/data-deletion">formulaire de demande de suppression</a>
          </p>
        </div>

        <div className="privacy-section">
          <h2>7. Sécurité de vos renseignements</h2>
          <p>
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles 
            appropriées pour protéger vos renseignements personnels contre :
          </p>
          <ul>
            <li>L'accès non autorisé</li>
            <li>La divulgation, la modification ou la destruction</li>
            <li>La perte accidentelle</li>
          </ul>
          <p>
            Ces mesures incluent : chiffrement des données, accès restreint aux renseignements personnels, 
            sauvegardes régulières, et surveillance continue de nos systèmes.
          </p>
        </div>

        <div className="privacy-section">
          <h2>8. Conservation des renseignements</h2>
          <p>
            Nous conservons vos renseignements personnels aussi longtemps que nécessaire pour 
            atteindre les fins pour lesquelles ils ont été recueillis, ou pour respecter nos 
            obligations légales. Généralement :
          </p>
          <ul>
            <li><strong>Demandes de soumission :</strong> conservées pendant 2 ans après la dernière interaction</li>
            <li><strong>Clients actifs :</strong> conservées pendant la durée de la relation commerciale + 7 ans (obligations fiscales)</li>
          </ul>
          <p>
            Après ces périodes, vos renseignements sont supprimés de manière sécurisée ou anonymisés.
          </p>
        </div>

        <div className="privacy-section">
          <h2>9. Cookies et technologies similaires</h2>
          <p>
            Notre site utilise des cookies pour améliorer votre expérience. Vous pouvez gérer 
            vos préférences de cookies via la bannière de consentement qui apparaît lors de votre 
            première visite. Les types de cookies utilisés :
          </p>
          <ul>
            <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site</li>
            <li><strong>Cookies analytiques :</strong> pour comprendre l'utilisation du site (avec votre consentement)</li>
            <li><strong>Cookies marketing :</strong> pour personnaliser votre expérience (avec votre consentement)</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>10. Services tiers</h2>
          <p>Notre site utilise les services suivants qui peuvent collecter des données :</p>
          <ul>
            <li><strong>Google Maps :</strong> pour la cartographie et le calcul de superficie 
            (Politique de confidentialité : <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a>)</li>
            <li><strong>Resend :</strong> pour l'envoi d'emails transactionnels</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>11. Modifications de cette politique</h2>
          <p>
            Nous pouvons modifier cette politique de confidentialité de temps à autre. La date 
            de la dernière mise à jour sera toujours indiquée en haut de cette page. Nous vous 
            encourageons à consulter régulièrement cette politique.
          </p>
        </div>

        <div className="privacy-section">
          <h2>12. Nous contacter</h2>
          <p>
            Pour toute question concernant cette politique de confidentialité ou vos renseignements 
            personnels, contactez-nous :
          </p>
          <div className="privacy-contact">
            <p>
              <strong>Naturellement Vert Fertilisation</strong><br />
              NEQ : 2280919921<br />
              Email : <a href="mailto:info@nvfertilisation.com">info@nvfertilisation.com</a><br />
              Téléphone : <a href="tel:4502101858">450 210 1858</a>
            </p>
          </div>
        </div>

        <div className="privacy-section privacy-cai">
          <h2>13. Commission d'accès à l'information du Québec</h2>
          <p>
            Si vous n'êtes pas satisfait de notre réponse à votre demande, vous avez le droit 
            de déposer une plainte auprès de la Commission d'accès à l'information du Québec :
          </p>
          <p>
            Site web : <a href="https://www.cai.gouv.qc.ca" target="_blank" rel="noopener noreferrer">www.cai.gouv.qc.ca</a><br />
            Téléphone : 1 888 528-7741
          </p>
        </div>

        <div className="privacy-footer-actions">
          <a href="/" className="privacy-btn">Retour au site</a>
          <a href="/data-deletion" className="privacy-btn privacy-btn-secondary">
            Demander la suppression de mes données
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
